import { Injectable } from '@angular/core';
import { IGuidService } from './iguid.service';
//import { ApiService } from '../index';

@Injectable()
export class GuidService {
  // gets a new long guid
  getNewLongGuid(): string {
    return ('' + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16)
    );
  }

  // gets a new short guid
  getNewShortGuid(): string {
    // intermediary array because we can't just reduce the Uint32Array to string array
    let str = [];
    str.push(...window.crypto.getRandomValues(new Uint32Array(22)));
    return str.reduce((a, b) => (a += b.toString(36))).slice(-16);
  }
}
